export const devicePixelRatio = () => {
  if (typeof window === 'undefined') return 1;
  return window.devicePixelRatio || 1;
  // let ratio = Math.round(window.devicePixelRatio || 1);
  // if (ratio > 2) ratio = 2;
  // return ratio;
};
